import { CarvanaThemeDeprecated } from '@carvana/showroom-theme';

const theme = {
  ...CarvanaThemeDeprecated,
  animations: {
    fast: 250,
    regular: 500,
    slow: 1000,
    timingFunctions: {
      easeInOutQuint: 'cubic-bezier(0.860, 0.000, 0.070, 1.000)'
    }
  }
};

export default theme;
